/* eslint-disable no-bitwise, prefer-destructuring */

/**
 * Function calculates HSP to determine whetehr color is light or dark
 */
const lightOrDark = (col) => {
  // Check the format of the color, HEX or RGB?
  let r;
  let g;
  let b;
  let color;
  if (col.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = col.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +`0x${col.slice(1).replace(col.length < 5 && /./g, "$&$&")}`;
    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return "light";
  }
  if (hsp <= 127.5 && hsp > 20) {
    return "dark";
  }
  return "darker";
};

/**
 * Function converts hex to RGB and lightens/darkens each r g b value
 */
const shadeColor = (col, amt) => {
  // removes # from hex
  const color = col.slice(1);
  let R = parseInt(color.substring(0, 2), 16);
  let G = parseInt(color.substring(2, 4), 16);
  let B = parseInt(color.substring(4, 6), 16);

  // to make the colour less bright than the input
  // change the following three "+" symbols to "-"
  R += amt;
  G += amt;
  B += amt;

  if (R > 255) R = 255;
  else if (R < 0) R = 0;

  if (G > 255) G = 255;
  else if (G < 0) G = 0;

  if (B > 255) B = 255;
  else if (B < 0) B = 0;

  const RR =
    R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG =
    G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB =
    B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

export const hoverColor = (color) => {
  const colorLevel = lightOrDark(color);
  if (colorLevel === "light") {
    return shadeColor(color, -18);
  }
  if (colorLevel === "dark") {
    return shadeColor(color, 18);
  }
  return shadeColor(color, 28);
};
